import store_operation from "@/store/mods/caisse/operations"
import { NumberToLetter } from 'convertir-nombre-lettre';
import $ from 'jquery'

export default {
    name: 'manage-forfait',
    components: {},
    props: {
        selected_societes: {
            type: Array,
            default: () => []
        },
        action_toggler: {
            type: Number,
            default: 0
        },
        detail_toggler: {
            type: Number,
            default: 0
        },
        user_info: {
            type: Object,
            default: () => {}
        },
        selected_facture: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            save_loading: false,
            can_show_confirmation: false,
            msg_error: '',
            selected_month: "",
            date: new Date(),
            is_loading: true,
            is_empty: false,
            load_error_msg: '',
            liste_societes: [],
            excluded_societes: [],
            montant_en_lettre: ''
        }
    },

    watch: {
        action_toggler() {
            console.log(">> TOGLER");
            
            this.selected_month = this.monthOfYear[this.date.getMonth()+1]
            
            this.can_show_confirmation = false
            this.clearError()
            this.checkIfSocietesHAsFacture()
        },

        selected_month() {
            console.log(">> month selected");
            this.checkIfSocietesHAsFacture()
        },

        detail_toggler() {
            if (this.selected_facture.info_complementaire && this.selected_facture.info_complementaire.montant > 0) {
                this.montant_en_lettre = NumberToLetter(this.selected_facture.info_complementaire.montant)
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        checkIfSocietesHAsFacture() {
            console.log(">> check excluded socs");
            this.is_loading = true
            this.load_error_msg = ''
            this.excluded_societes = []
            this.liste_societes = []
            const data = {
                month: this.selected_month.id,
                souscripteurs: this.selected_societes
            }
            store_operation.checkIfSocietesHasFactureForfait(data).then((response) => {
                if (response.success) {
                    this.liste_societes = response.data.filter(el => el.has_facture === false)
                    this.excluded_societes = response.data.filter(el => el.has_facture === true)
                    if (this.liste_societes.length == 0) {
                        this.is_empty = true 
                    } else {
                        this.is_empty = false
                    }
                } else {
                    this.load_error_msg = 'Merci de s\'assurer avoir choisir les sociétés !'
                }

                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.load_error_msg = 'Une erreur s\'est produite lors du chargement !'
            })
        },

        handleQtyChange(index) {
            this.clearError()
            const initial_qty = this.liste_societes[index].qte_initiale
            let input_qty = document.getElementById('qty-'+index)
            if (!input_qty) {
                return;
            }

            let qty = input_qty.value
            qty = this.cleanNumber(qty)
            if (qty === '') {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                this.liste_societes[index].qte = ''
                return;
            }

            const is_greater_zero = this.checkIfNumberGreaterThanZero(qty)
            if (!is_greater_zero) {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                input_qty.value = initial_qty
                this.liste_societes[index].qte = initial_qty
                this.calculatePT(index)
                
                return;
            }
            this.liste_societes[index].qte = qty

            this.calculatePT(index)
        },

        handlePUChange(index) {
            this.clearError()
            const initial_pu = this.liste_societes[index].pu_initial
            let input_pu = document.getElementById('pu-'+index)
            if (!input_pu) {
                return;
            }

            let pu = input_pu.value
            pu = this.cleanNumber(pu)
            if (pu === '') {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                this.liste_societes[index].pu = ''
                return;
            }

            const is_greater_zero = this.checkIfNumberGreaterThanZero(pu)
            if (!is_greater_zero) {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                input_pu.value = initial_pu
                this.liste_societes[index].pu = initial_pu
                this.calculatePT(index)
                
                return;
            }
            this.liste_societes[index].pu = pu
            this.calculatePT(index)
        },

        calculatePT(index) {
            this.liste_societes[index].montant = this.liste_societes[index].qte * this.liste_societes[index].pu
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            this.msg_error = ''
        },

        clearError() {
            this.msg_error = ''
        },

        formValidator() {
            let one_is_empty = false
            this.liste_societes.forEach(el => {
                if (el.pu === "" || el.pu === null) {
                    this.msg_error = "Le prix unitaire d'une ou plusieurs sociétés n'a pas été défini !"
                    one_is_empty = true
                    return;
                }
                if (el.qte === "" || el.qte === null) {
                    this.msg_error = "La quantité d'une ou plusieurs sociétés n'a pas été défini !"
                    one_is_empty = true
                    return
                }
            });
            return one_is_empty
        },

        saveDepot(selector) {
            const is_empty = this.formValidator()
            if (is_empty === true) {
                return;
            }

            if (!this.can_show_confirmation) {
                this.can_show_confirmation = true
                return;
            }

            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                this.msg_error = "Merci de confirmer le dépôt de la facture des sociétés choisies !"
                return;
            }

            const data = {
                data_type: 'facture_forfait',
                souscripteurs: this.liste_societes,
                is_assurance: 0,
                etat: 2,
                month: this.selected_month.id,
                taux_change: Number(this.currency_info && this.currency_info.rate) > 0 ? Number(this.currency_info.rate) : null,
                user_id: this.user_info.user_id,
                user: this.user_info.name
            }
            console.log("v d ",data);
            
            
            this.save_loading = true
            store_operation.deposerFactureSociete(data).then((response) => {
                if (response.success) {
                    this.$refs.dep_fac_soc.click()
                    this.successToast(response.message)

                    this.$emit("emitRedirectToListeFacture")  
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        scrollTo(anchor) {
            setTimeout(() => {
                let scroll_value = $('#'+anchor).offset().top
                $('#scrl-anchor').animate({
                    scrollTop: scroll_value
                }, 800, function() {});
            }, 1000);
        },

        setPrintFactureForfait() {
            console.log("INIT PRINT");
            
            const invoice_data = {
                selected_facture: this.selected_facture,
                total_facture: this.selected_facture.info_complementaire.montant,
                total_en_lettre: this.montant_en_lettre,
            }

            this.$emit('emitSetFactureForfaitToPrint', invoice_data) 
        }
    }
}
